import { useTranslate } from "ra-core";
import type { ReactNode } from "react";

import { useIsMobile } from "@/hooks/use-mobile";
import { MobileContent } from "@/components/atomic-crm/layout/MobileContent";
import MobileHeader from "@/components/atomic-crm/layout/MobileHeader";

import { useEsAdmin } from "../datos/useEsAdmin";

/**
 * Marco de las pantallas solo para Jan y Robert (Equipo, Sin asignar, Comisiones): título,
 * ayuda y, en móvil, la cabecera de Atomic. Un setter que llegue por URL ve el aviso; lo
 * que de verdad lo impide es la base (RLS y funciones solo para administradores).
 */
export const PaginaAdmin = ({
  titulo,
  ayuda,
  acciones,
  children,
}: {
  titulo: string;
  ayuda?: string;
  acciones?: ReactNode;
  children: ReactNode;
}) => {
  const translate = useTranslate();
  const isMobile = useIsMobile();
  const esAdmin = useEsAdmin();

  const cuerpo = !esAdmin ? (
    <p className="text-muted-foreground">
      {translate("nevora.equipo.solo_admin")}
    </p>
  ) : (
    <div className="space-y-4 pb-8">
      {ayuda || acciones ? (
        <div className="flex flex-wrap items-end justify-between gap-3">
          {ayuda ? (
            <p className="text-sm text-muted-foreground max-w-3xl">
              {translate(ayuda)}
            </p>
          ) : (
            <span />
          )}
          {acciones}
        </div>
      ) : null}
      {children}
    </div>
  );

  if (isMobile) {
    return (
      <>
        <MobileHeader>
          <h1 className="titulo-seccion">{translate(titulo)}</h1>
        </MobileHeader>
        <MobileContent>{cuerpo}</MobileContent>
      </>
    );
  }
  return (
    <div className="mt-2 space-y-4">
      <h1 className="titulo-pagina">{translate(titulo)}</h1>
      {cuerpo}
    </div>
  );
};

/** Selector de mes («aaaa-mm») de Equipo y Comisiones. */
export const SelectorMes = ({
  mes,
  cambiar,
}: {
  mes: string;
  cambiar: (mes: string) => void;
}) => {
  const translate = useTranslate();
  return (
    <label className="flex items-center gap-2 text-sm">
      <span className="text-muted-foreground">
        {translate("nevora.equipo.mes")}
      </span>
      <input
        type="month"
        value={mes}
        onChange={(e) => e.target.value && cambiar(e.target.value)}
        className="h-9 rounded-md border border-input bg-transparent px-3 text-sm"
        data-testid="selector-mes"
      />
    </label>
  );
};
